'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgSendFilled(props) {
    return (React__default.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", ...props },
        React__default.default.createElement("path", { d: "M3.49293 6.8238C3.19095 6.67303 3 6.36351 3 6.02479V3.89342C3 3.23101 3.69329 2.79955 4.28384 3.09444L12.5071 7.20071C13.1643 7.52887 13.1643 8.47048 12.5072 8.79867L4.28388 12.9055C3.69333 13.2005 3 12.769 3 12.1066V9.97521C3 9.63653 3.19091 9.32704 3.49284 9.17625L5.84841 7.99982L3.49293 6.8238Z", fill: "currentColor" })));
}

module.exports = SvgSendFilled;
//# sourceMappingURL=Send.js.map
